import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

import { useAuthStore } from '@features/auth/stores/useAuthStore';
import { isAuthSatisfied } from '@features/auth/utils/isAuthSatisfied';
import { getAuthGuardAllowGuest, isAuthGuardedPath } from '@features/auth/utils/isAuthGuardedPath';
import AuthModal from '@features/auth/components/AuthModal';

export default function AuthOverlay() {
  const blocker = useBlocker(({ nextLocation }) => {
    if (!isAuthGuardedPath(nextLocation.pathname)) return false;
    const allowGuest = getAuthGuardAllowGuest(nextLocation.pathname);
    return !isAuthSatisfied(useAuthStore.getState(), { allowGuest });
  });

  const blockedPathname = blocker.state === 'blocked' ? blocker.location.pathname : undefined;
  const allowGuest = blockedPathname ? getAuthGuardAllowGuest(blockedPathname) : false;
  const satisfied = useAuthStore((state) => (blockedPathname ? isAuthSatisfied(state, { allowGuest }) : true));

  useEffect(() => {
    if (blocker.state === 'blocked' && satisfied) {
      blocker.proceed();
    }
  }, [satisfied, blocker]);

  if (blocker.state !== 'blocked') return null;

  const handleDismissal = () => blocker.reset();

  return <AuthModal onOpenChange={handleDismissal} allowGuest={allowGuest} />;
}
